<template lang="pug">
.main-wrapper
    .nav-wrapper
        Navigation
    VGrid.container.project-content.fade-in(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax1")
                    img.main-image(
                        src="@/assets/images/diamond/pioneer-mockup.jpg",
                        data-depth="0.3"
                    )
                    img.dot-pattern(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square(data-depth="0.15")
                    .filled-squares(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Pioneer Diamond Tendering Platform
                        .title-section-description
                            .company By Influx.Studio
                            .description The Pioneer Tendering platform was developed from the ground<br/> up to offer an easy-to-use and secure platform where suppliers<br/> can tenderlarge amounts of diamonds to potential buyers. <br/>Facilitators at the Pioneer Tender House can use the platform <br/>to easily manage the tendering processes from start to end,<br/> while ensuring all data is kept strictly confidential.
                    .title-section-content
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Branding, UI/UX, Web Development
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#project") 02 Project Demonstration
                            .menu-item
                                a.label(data-link="#solutions") 03 Solutions
                            .menu-item
                                a.label(data-link="#technologies") 04 Technologies
            .title-section-gridlines

    .light
        VGrid#overview.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Overview
            VRow.overview-section-spacing
                VCol(variant="xs-10")
                    VRow.space-around
                        VCol(variant="xs-6")
                            .general-item 
                                span.title The Mission
                                p.description Tendering of valuable goods are always subject to some form of corruption. For this reason, there was a need by the Pioneer Diamond Tendering House to develop a secure and fully confidential tendering platform to facililitate the tendering process between buyers and suppliers,
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title Services
                                p.description The Pioneer Tendering Platform offers a fully secure tendering platform for buyers and suppliers.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title The Outcome
                                p.description The Pioneer Diamond Tendering Platform is secure and fully confidential, ensuring user data is kept safe and fully encrypted through all stages of the tendering process. This protects users from unrightful partnerships and price hiking in the tendering process.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title The Impact
                                p.description Users are far more confident in the tendering process, and from a management standpoint, tenders are handled in a far more organised and efficient manner.
                VCol(variant="xs-2") 
                    span.general-section-share Share This
                    .general-section-social-share
                        VRow
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://www.facebook.com/",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/facebook.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://twitter.com/?lang=en",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/twitter.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://www.instagram.com/",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/insta.svg") 
                    .general-section-project-scope
                        span.scope Scope of Project
                        .scope-item Frontend Design
                        .scope-item Backend Development
                        .scope-item UI/UX
                        .scope-item Branding

    .dark
        VGrid#project.container(variant="container")
            VRow
                VCol.section-title.light-text(variant="xs-5") Project examples
                    VRow.overview-section-spacing
                        VCol(variant="xs-12")
                            .general-item.dark-theme-trigger(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title.light-text Real-time statistics and management
                                p.description.light-text Pioneer features an easy-to-use admin management portal where facilitators of the tendering process can gather useful insights into their customer-base, as well as easily manage secure access to the different tenders and subsystems. This allows fine control over the data and who has access to it.
                                span.title.light-text Confidential tendering and payouts
                                p.description.light-text Pioneer allows administrators to create and manage tenders for potential buyers. Tenders are ran for specific timeframes, wherein results are not immediately available to any users, including administrators. Tenders are automatically released to administrators at the end of the tender cutoff time, thereafter a detailed report can be generated of the tender results. Administrators can then release these results to the winning bidder, and funds are automatically released to the appropriate party.
                VCol.image-scroll-section(variant="xs-7")
                    .laptop-image-section 
                        img.image(
                            src="@/assets/images/diamond/Pioneer-Tender-Application.jpg",
                            data-depth="0.3"
                        )
                    .laptop-image-section 
                        img.image(
                            src="@/assets/images/diamond/Pioneer-Dashboard.jpg",
                            data-depth="0.3"
                        )

    .light
        VGrid#solutions.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technical Solutions
            VRow
                VCol(variant="xs-6") 
                    .general-item
                        span.title Problems
                        ol 
                            li.list-item 1. Tenders can be easily manipulated by buyers to get the price they want.
                            li.list-item 2. Tenders are current paper-based, which contains sensitive information about all parties involved.
                            li.list-item 3. Tender management takes a long time to complete before and after tenders have been released.
                            li.list-item 4. Paper-based tendering requires manual statistical analysis.
                VCol(variant="xs-6") 
                    .general-item
                        span.title Solutions
                        ol 
                            li.list-item 1. Tender results are hidden from all parties involved until a tender has ended. This ensures no bidder has access to other bidders' information.
                            li.list-item 2. Tenders are entirely digital stored on a secure webserver. All tenders are fully encrypted.
                            li.list-item 3. The tendering process is streamlined with easy-to-use forms and automations.
                            li.list-item 4. Statistics are automatically generated and updated in real-time based on past tenders

    .light
        VGrid#technologies.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technologies Used
            VRow.align-center
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/html.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/css.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/asp.png",
                        data-depth="0.3"
                    ) 
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/vue.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/webpack.png",
                        data-depth="0.3"
                    )
            VRow.align-center
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/sql.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/azure.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/docker.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/linux.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/nginx.png",
                        data-depth="0.3"
                    )

    .cream
        VGrid.container(variant="container")
            VRow.contact-us
                VCol(variant="xs-12")
                    h1.align-center.contact-description Want to work with us?
                    .align-center.scroll-down
                        router-link.contact-button.primary-button(
                            :to="{ name: 'home', query: { c: true } }",
                            data-cursor-shrink
                        ) Start A Project
                VCol(variant="xs-12")
                    .icon-scroll 
                    p.scroll-text Next Project: Blink

    VGrid.container.project-content(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax2")
                    img.main-image-2.large(
                        src="@/assets/images/blink/blink-poster.png",
                        data-depth="0.3"
                    )
                    img.dot-pattern-2(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square-2(data-depth="0.15")
                    .filled-squares-2(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Blink
                        .title-section-description
                            .company By Influx.Studio
                            .description A horror student short film
                    .title-section-content-2
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Film
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#planning") 02 Planning
                            .menu-item
                                a.label(data-link="#trailer") 03 Trailer
                            .menu-item
                                a.label(data-link="#film") 04 Film
                            .menu-item
                                a.label(data-link="#solutions") 05 Solutions
                            .menu-item
                                a.label(data-link="#camera") 06 Technologies
            .title-section-gridlines

    .static-elements
        .static-wrapper-inner.navigation-container
            //- Navigation.staticnav
        .static-wrapper-inner.static-footer
            p.copyright-info Copyright &copy; 2020 | Design by #[a(href="/contact") Influx Studios]
</template>

<script>
import Navigation from "@/components/navigation.vue";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import Parallax from "parallax-js";
import { EventBus } from "@/events/global-bus.js";
import ScrollMagic from "scrollmagic";
import $ from "jquery";

import Vue from "vue";
import FlexboxgridVue from "@vivid-web/flexboxgrid-vue";

import VueAnimateOnScroll from "vue-animate-onscroll";

Vue.use(VueAnimateOnScroll);

Vue.use(FlexboxgridVue);

export default {
    name: "Single-Work",
    computed: {
        workname() {
            return this.$route.params.workname;
        },
    },
    components: {
        Navigation,
    },
    metaInfo() {
        return {
            title: this.workname,
        };
    },
    mounted() {
        function scrollToElement(selector) {
            $("html, body")
                .stop(true, false)
                .animate(
                    {
                        scrollTop: $(selector).offset().top,
                    },
                    500,
                    "swing"
                );
        }

        $(document).on("click", ".menu-item a", function (e) {
            e.preventDefault();
            scrollToElement($(this).attr("data-link"));
            return false;
        });

        window.scrollTo(0, 0);

        new Parallax(this.$refs.parallax1, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        new Parallax(this.$refs.parallax2, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        let self = this;

        $(window).scroll(function () {
            if (
                $(window).scrollTop() + $(window).height() ==
                    $(document).height() &&
                self.$route.name == "diamond"
            )
                self.$router.push({ name: "blink" });
        });

        var controller = new ScrollMagic.Controller();
        new ScrollMagic.Scene({
            triggerElement: ".dark-theme-trigger",
            offset: 250,
            duration: 500,
        })
            .setPin(".image-scroll-section")
            .setPin(".dark-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: ".scroll-down",
            offset: 0,
        })
            .on("start", function () {
                if (this.$route.name != "home" || this.$route.name != "works")
                    $("html, body").animate(
                        { scrollTop: $(document).height() },
                        2000
                    );
            })
            .addTo(controller);

        EventBus.$emit("rescan-cursor");
    },
    beforeDestroy() {
        $(window).off("scroll");
    },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: $cl-cream;
    box-sizing: border-box;
    //
}
.nav-wrapper {
    margin-top: $body-padding-desktop-y;
    padding: 0 $body-padding-desktop-x;
}

// Title Layout Section
.title-section {
    position: relative;
    background-color: $cl-cream;
}

.title-section-gridlines {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        to right,
        transparentize(#575757, 0.9),
        transparentize(#575757, 0.9) 1px,
        $cl-cream 1px,
        $cl-cream 10%
    );
    z-index: 0;
}

.title-section-wrapper {
    width: 100%;
    height: 100%;
    background-color: $cl-cream;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    position: relative;
    z-index: 2;

    .title-section-inner-wrapper {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        .title-section-title {
            color: $cl-grey;
            font-size: 7rem;
            line-height: 1.2em;
        }

        .title-section-image {
            margin-right: 8rem;
            position: relative;

            .main-image {
                max-width: 28rem;
                position: relative;
                z-index: 3;
            }

            .main-image-2 {
                max-width: 30rem;
                position: relative;
                z-index: 3;

                &.large {
                    max-width: 40rem;
                }
            }

            .dot-pattern {
                position: absolute;
                width: 60%;
                margin-left: -7rem;
                margin-top: 16.5rem;
                z-index: 1;
            }

            .outline-square {
                position: absolute;
                width: 75%;
                height: 75%;
                border: 1px solid $cl-grey;
                margin-top: -2rem;
                margin-left: 7rem;
                z-index: 1;
            }

            .filled-squares {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 7rem;
                    height: 7rem;
                    bottom: 25rem;
                    right: -2.5rem;
                    background-color: $cl-red;
                }

                &::after {
                    content: "";
                    position: absolute;
                    width: 16rem;
                    height: 16rem;
                    top: -3.6%;
                    left: -3.6rem;
                    border: 1px solid $cl-grey;
                }
            }

            .dot-pattern-2 {
                position: absolute;
                width: 70%;
                margin-left: -8rem;
                margin-top: 3rem;
                z-index: 1;
            }

            .outline-square-2 {
                position: absolute;
                width: 75%;
                height: 100%;
                border: 1px solid $cl-grey;
                margin-top: -5rem;
                margin-left: 5rem;
                z-index: 1;
            }

            .filled-squares-2 {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 9.6rem;
                    height: 9.6rem;
                    bottom: -2.4rem;
                    right: -2.4rem;
                    background-color: $cl-red;
                }

                &::after {
                    content: "";
                    position: absolute;
                    width: 16rem;
                    height: 16rem;
                    top: -3.6%;
                    left: -3.6rem;
                    border: 1px solid $cl-grey;
                }
            }
        }

        .title-section-content-container {
            margin-top: 4.8rem;

            .project-information {
                display: flex;
                flex-direction: row;
            }

            .title-section-content {
                margin-left: 24rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;
                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-content-2 {
                margin-left: 5rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;
                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-description {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                margin-left: 14rem;
                white-space: nowrap;

                .company {
                    color: $cl-red;
                    font-weight: 600;
                    font-size: 1.4rem;
                }

                .description {
                    color: $cl-grey;
                    font-weight: 500;
                    font-size: 1.4rem;
                    margin-bottom: 1.8rem;
                }
            }
        }
    }
}

.light {
    background-color: white;
    position: relative;
    width: 100%;
}

.light-grey {
    background-color: #f6f6f6;
    position: relative;
    width: 100%;
}

.cream {
    background-color: $cl-cream;
    position: relative;
    width: 100%;
}

.dark {
    background-color: $cl-grey;
    position: relative;
    width: 100%;
}

.container {
    @media (min-width: 1200px) and (max-width: 1599px) {
        max-width: 80%;
    }

    @media (min-width: 1600px) {
        max-width: 75%;
    }

    &.project-content {
        height: 90vh;

        &.fade-in {
            animation: fadeIn ease 2s;
        }

        @keyframes fadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }

    &.project-change {
        height: 100vh;
    }

    position: relative;

    .section-title {
        color: $cl-grey;
        font-size: 3rem;
        font-weight: 400;
        font-family: "Poppins", Helvetica, sans-serif;
        margin-top: 6rem;

        &.line {
            position: relative;
            &::after {
                bottom: 0;
                height: 3px;
                background-color: $cl-red;
                left: 0;
                width: 5rem;
                content: "";
                position: absolute;
            }
        }

        &.light-text {
            color: white;
        }
    }

    .align-center {
        display: flex;
        justify-content: center;
        margin-bottom: 5rem;
        margin-top: 1.5rem;

        .percentage {
            font-size: 4rem;
            color: $cl-red;
        }

        .results-description {
            font-size: 1.5rem;
            font-weight: 500;
        }
    }

    .icon-scroll,
    .icon-scroll:before {
        position: absolute;
        left: 50%;
        z-index: 100;
    }

    .scroll-text {
        font-size: 1.6rem;
        font-weight: 500;
        position: absolute;
        left: 52%;
        margin-top: 1rem;
        opacity: 0.7;
        margin-left: 1rem;
        z-index: 100;
    }

    .icon-scroll {
        width: 40px;
        height: 70px;
        margin-left: -20px;
        top: 100%;
        margin-top: -35px;
        box-shadow: inset 0 0 0 1px $cl-grey;
        border-radius: 25px;
    }

    .icon-scroll:before {
        content: "";
        width: 8px;
        height: 8px;
        background: $cl-grey;
        margin-left: -4px;
        top: 8px;
        border-radius: 4px;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-name: scroll;
    }

    @keyframes scroll {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translateY(46px);
        }
    }

    .contact-us {
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
        margin-top: 1.5rem;

        .contact-description {
            font-size: 4rem;
            font-weight: 600;
            margin-top: 4rem;
            margin-bottom: 4rem;
        }

        .contact-button {
            background-color: $cl-cream;
            margin-top: 0;

            &:hover {
                background-color: $cl-red;
            }
        }

        &.align-center {
            display: flex;
            justify-content: center;
        }
    }

    .overview-section-spacing {
        margin-top: 1.5rem;
        margin-bottom: 4rem;
    }

    .image-carousel {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10rem;

        .carousel-item {
            width: 100rem;
        }
    }

    .side-scroll {
        margin-top: 6rem;
        margin-bottom: 6rem;
    }

    .slogan-section {
        display: flex;
        justify-content: center;
        text-align: center;

        .brand-slogan {
            font-weight: 600;
            font-size: 6rem;

            .slogan-outline {
                border: 3px solid $cl-red;
                padding-right: 2rem;
                padding-left: 2rem;
                transition: background-color 1s;

                /* &:hover {
                    color: white;
                    background-color: $cl-grey;
                } */
            }
        }
    }

    .image-scroll-section {
        display: flex;
        flex-direction: column;
        margin-top: 8rem;
        margin-bottom: 5rem;

        .image-section {
            position: relative;
            margin-bottom: 2rem;

            .left-image {
                position: relative;
            }

            .right-image {
                position: relative;
                left: 30rem;
            }
        }

        .laptop-image-section {
            position: relative;
            margin-bottom: 2rem;

            .image {
                position: relative;
            }
        }
    }

    .section-description {
        color: $cl-grey;
        font-weight: 500;
        font-size: 1.5rem;
        margin-top: 0rem;
        margin-bottom: 2rem;
    }

    .general-item {
        .title {
            color: $cl-grey;
            font-weight: 600;
            font-size: 2rem;
            font-family: "Poppins", Helvetica, sans-serif;

            &.light-text {
                color: white;
            }
        }

        .description {
            color: $cl-grey;
            font-weight: 500;
            font-size: 1.5rem;
            margin-top: 1rem;
            margin-bottom: 2rem;

            &.light-text {
                color: white;
            }
        }

        ol {
            line-height: 1.8em;
            margin-top: 1.5rem;
        }

        ol > li.list-item {
            font-weight: 500;
            font-size: 1.5rem;
        }
    }

    .general-section-share {
        font-weight: 700;
        font-size: 1.3rem;
    }

    .general-section-social-share {
        display: flex;
        flex-direction: row;
        margin-top: 1rem;

        .contact-info-social {
            &:hover {
                img {
                    opacity: 1;
                }
            }
            img {
                width: 2.2rem;
                height: 2.2rem;
                opacity: 0.75;
                transition: opacity 200ms ease-in-out;
            }

            &:not(:last-child) {
                margin-right: 1rem;
            }
        }
    }

    .general-section-project-scope {
        margin-top: 5rem;
        .scope {
            font-weight: 700;
            font-size: 1.4rem;
        }
        .scope-item {
            font-weight: 500;
            font-size: 1.3rem;
        }
    }

    .website-link {
        font-weight: 700;
        font-size: 1.4rem;
        color: $cl-red;
        margin-top: 5rem;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $cl-grey;
        }
    }

    .technology-img {
        filter: grayscale(100%);
        width: 20rem;
        height: 7rem;
        object-fit: contain;

        &:hover {
            filter: grayscale(0%);
        }
    }
}

.static-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    pointer-events: none;

    .copyright-info {
        color: $cl-cream-darker;
    }

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        position: absolute;

        .copyright-info {
            display: none;
        }
    }
}
</style>